import React, { lazy } from 'react';
import { authMenu, dashboardMenu, loansMenu, profileMenu } from 'menu';

const AUTH = {
	LOGIN: lazy(() => import('pages/presentation/auth/AuthPage')),
	CONFIRM_SIGNUP: lazy(() => import('pages/presentation/auth/ConfirmSignup')),
	CONFIRM_LOGIN: lazy(() => import('pages/presentation/auth/Confirm2Fa')),
	FORGET_PASSWORD: lazy(() => import('pages/presentation/auth/Forget')),
	CONFIRM_RESET: lazy(() => import('pages/presentation/auth/ConfirmForget')),
	RESET_PASSWORD: lazy(() => import('pages/presentation/auth/ResetPassword')),
};

const LANDING = {
	DASHBOARD: lazy(() => import('pages/presentation/dashboard/DashboardPage')),
	CUSTOMER: lazy(() => import('pages/presentation/dashboard/CustomerLookup')),
	SINGLE_CUSTOMER: lazy(() => import('pages/presentation/dashboard/SingleCustomer')),
};

const LOANS_MENU = {
	LOAN_INDEX: lazy(() => import('pages/presentation/loan/LoanHistories')),
	BOOK_LOAN: lazy(() => import('pages/presentation/loan/CreateLoan')),
	SINGLE_LOAN: lazy(() => import('pages/presentation/loan/SingleLoan')),
	BOOK_TOPUP: lazy(() => import('pages/presentation/loan/BookTopup')),
	CUSTOMER_LOOKUP: lazy(() => import('pages/presentation/loan/CustomerLookup')),
	PREVIEW_LOAN: lazy(() => import('pages/presentation/loan/PreviewLoan')),
	LOAN_CALCULATOR: lazy(() => import('pages/presentation/loan/LoanCalculator')),
};

const PROFILE = {
	PROFILE: lazy(() => import('pages/presentation/profile/Profile')),
};

const presentation = [
	/**
	 * AUTH
	 */
	{
		path: authMenu.login.path,
		element: <AUTH.LOGIN />,
	},
	{
		path: authMenu.confirmSignUp.path,
		element: <AUTH.CONFIRM_SIGNUP />,
	},
	{
		path: authMenu.confirmLogin.path,
		element: <AUTH.CONFIRM_LOGIN />,
	},
	{
		path: authMenu.forgetGroup.subMenu.forgetPassword.path,
		element: <AUTH.FORGET_PASSWORD />,
	},
	{
		path: authMenu.forgetGroup.subMenu.confirmation.path,
		element: <AUTH.CONFIRM_RESET />,
	},
	{
		path: authMenu.forgetGroup.subMenu.resetPassword.path,
		element: <AUTH.RESET_PASSWORD />,
	},
	/**
	 * Landing
	 */
	{
		path: dashboardMenu.dashboard.path,
		element: <LANDING.DASHBOARD />,
	},
	{
		path: dashboardMenu.customers.path,
		element: <LANDING.CUSTOMER />,
	},
	{
		path: `${dashboardMenu.customers.path}/:id`,
		element: <LANDING.SINGLE_CUSTOMER />,
	},
	/**
	 * LOANS
	 */
	{
		path: loansMenu.loanHistory.path,
		element: <LOANS_MENU.LOAN_INDEX />,
	},
	{
		path: loansMenu.bookLoan.path,
		element: <LOANS_MENU.BOOK_LOAN />,
	},
	{
		path: `${loansMenu.bookLoan.path}/:id`,
		element: <LOANS_MENU.BOOK_LOAN />,
	},
	{
		path: `${loansMenu.loanHistory.path}/view/:id`,
		element: <LOANS_MENU.SINGLE_LOAN />,
	},
	{
		path: loansMenu.searchCustomer.path,
		element: <LOANS_MENU.CUSTOMER_LOOKUP />,
	},
	{
		path: `${loansMenu.bookTopUp.path}/:id`,
		element: <LOANS_MENU.BOOK_TOPUP />,
	},
	{
		path: `${loansMenu.loanPreview.path}/:id`,
		element: <LOANS_MENU.PREVIEW_LOAN />,
	},
	{
		path: loansMenu.loanCalculator.path,
		element: <LOANS_MENU.LOAN_CALCULATOR />,
	},
	/**
	 * Profile
	 */
	{
		path: profileMenu.profile.path,
		element: <PROFILE.PROFILE />,
	},
];
const contents = [...presentation];

export default contents;
